// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flexible-textinput {
  display: block;
  width: 100%;
  height: 40px;
  padding: 12px;
  line-height: 18px;
  color: var(--dark-color-dark);
  background-color: var(--input-bg-color);
  background-clip: padding-box;
  border: 1px solid var(--border-color);
  appearance: none;
  border-radius: 4px;
  transition: all 0.15s;
}
.flexible-textinput::placeholder {
  color: #c2c8d2;
  opacity: 1;
}
.flexible-textinput:focus {
  background-color: var(--input-bg-color);
  border: 1px solid var(--primary-color-main);
  outline: 0;
}
.flexible-textinput:disabled {
  background: var(--disabled-bg-color);
  color: var(--disabled-font-color);
  cursor: default;
  -webkit-appearance: none;
  border: 1px solid var(--disabled-border-color);
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/FlexibleTextInput.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AACF;AACE;EACE,cAAA;EACA,UAAA;AACJ;AAEE;EACI,uCAAA;EACA,2CAAA;EACA,UAAA;AAAN;AAGE;EACE,oCAAA;EACA,iCAAA;EACA,eAAA;EACA,wBAAA;EACA,8CAAA;AADJ","sourcesContent":[".flexible-textinput {\r\n  display: block;\r\n  width: 100%;\r\n  height: 40px;\r\n  padding: 12px;\r\n  line-height: 18px;\r\n  color: var(--dark-color-dark);\r\n  background-color: var(--input-bg-color);\r\n  background-clip: padding-box;\r\n  border: 1px solid var(--border-color);\r\n  appearance: none;\r\n  border-radius: 4px;\r\n  transition: all 0.15s;\r\n\r\n  &::placeholder {\r\n    color: #c2c8d2;\r\n    opacity: 1;\r\n  }\r\n\r\n  &:focus {\r\n      background-color: var(--input-bg-color);\r\n      border: 1px solid var(--primary-color-main);\r\n      outline: 0;\r\n  }\r\n\r\n  &:disabled {\r\n    background: var(--disabled-bg-color);\r\n    color: var(--disabled-font-color);\r\n    cursor: default;\r\n    -webkit-appearance: none;\r\n    border: 1px solid var(--disabled-border-color);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
